// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3ZNHt","left":"StickyBox_left__uaiKv","right":"StickyBox_right__3yw5x"};